import * as React from 'react'
import { ReactElement } from 'react'
import EntityPage, { EntityPageProps, ParentProps } from './EntityPage'
import { Route } from 'react-router'
import GlobalNoteOverview from './Note/GlobalNoteOverview'
import NoteOverview from './Note/NoteOverview'
import { NoteListProps } from '../components/List/Note/NoteList'

type Props = EntityPageProps & {
    overviewProps?: NoteListProps
}

export const noteBaseUrl = '/note'

export default function Notes(props: Props): ReactElement {
    return (
        <EntityPage {...props} baseUrl={noteBaseUrl}>
            {({ route, baseUrl }: ParentProps) => (
                <Route
                    exact
                    path={route}
                    render={() => (route === noteBaseUrl ? <GlobalNoteOverview /> : <NoteOverview {...props.overviewProps} baseUrl={baseUrl} />)}
                />
            )}
        </EntityPage>
    )
}
